<!--
 * @Author: your name
 * @Date: 2020-08-24 09:11:30
 * @LastEditTime: 2021-09-22 17:21:50
 * @LastEditors: your name
 * @Description: In User Settings Edit
 * @FilePath: /mmeui/src/components/DashBoard.vue
-->
<template>
  <div style="height: 100%">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">
          <span style="color: #4a90e2">
            <i class="el-icon-location"></i>
            {{ $t('dashBoard.首页') }}
          </span>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div id="container" style="width: 100%; height: 100%"></div>
  </div>
</template>

<script>
import { myequippoint } from '../service/getData'
let marker, map
import { getToken } from '../utils/auth'
export default {
  name: 'app',
  data() {
    return {
      listPoint: null,
    }
  },
  mounted() {
    if (!getToken()) return false
    this.listPoint = []
    ;(async () => {
      let result = await myequippoint()
      let data = result.data
      if (!data) return null
      data.map((item) => {
        let temp = []
        temp.push(item.jd)
        temp.push(item.wd)
        this.listPoint.push(temp)
      })
      map = new AMap.Map('container', {
        layers: [new AMap.TileLayer.Satellite()],
        zoom: 7,
        zooms: [1, 7],
        resizeEnable: true,
        center: this.listPoint[0],
      })
      this.listPoint.map((index, i) => {
        addMarker(index, i, 'point.png')
      })
      map.setFitView()
    })()
  },
}
function addMarker(point, i, icon = 'point.png') {
  marker = new AMap.Marker({
    icon: '/static/' + icon,
    position: point,
  })
  marker.setMap(map)
}
</script>
<style lang="scss" scoped>
#map {
  background: white;
  height: 90%;
}
</style>
<style>
.amap-marker-label {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  text-align: center;
  line-height: 20px;
  font-size: 16px;
  background: #3e95fa;
  color: white;
}
</style>
